import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import {
	adminSessionQueryOptions,
	warmInstanceBranding
} from '@/query/query-options'
import { OperatorSidebar } from '@/routes/-components/operator-sidebar/operator-sidebar'

export const Route = createFileRoute('/(private)')({
	ssr: false,
	beforeLoad: async ({ context }) => {
		// The session gate. `fetchQuery` rather than `ensureQueryData` because
		// this is the point where the session may not be in the cache yet, and
		// guards cannot suspend.
		const session = await context.queryClient.fetchQuery(
			adminSessionQueryOptions()
		)

		// Decide and stop; do not return data. Route context carries nothing
		// session-derived — components re-read the same queryOptions.
		//
		// AND IT IS THE ONLY GUARD THIS APP HAS, which is a decision rather
		// than an omission. The console's identity lives in its own realm and
		// its own tables, with no self-service provisioning (OPSSTD-4725), so
		// a tenant user has no row to authenticate against here: an
		// authenticated session on this artifact IS the operator. The session
		// contract carries no role, so there is nothing for a role guard to
		// compare — and `routing.md` grants one only where the artifact can
		// hold a session that is not allowed in.
		//
		// Only an EMPTY session lands here. Backend and network failures reach
		// the route error boundary, so an unreachable server is never
		// reported to the operator as "you are signed out".
		if (session.sessionType !== 'authenticated') {
			throw redirect({ to: '/login' })
		}
	},
	// The sidebar draws the reseller's logo and name, so they are read before
	// it renders and never pop in after the first paint. Never fails the page.
	loader: ({ context }) => warmInstanceBranding(context.queryClient),
	component: OperatorPrivateLayout
})

function OperatorPrivateLayout() {
	return (
		<OperatorSidebar>
			<Outlet />
		</OperatorSidebar>
	)
}
